export const formatDate = (date) => {
  if (!date) return 'N/A';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatRelativeTime = (date) => {
  if (!date) return 'N/A';
  
  const now = new Date();
  const diff = now - new Date(date);
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 30) return `${days}d ago`;
  
  return formatDate(date);
};

export const formatFileSize = (bytes) => {
  if (!bytes) return 'N/A';
  
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
};

export const formatNumber = (num) => {
  if (!num && num !== 0) return '0';
  
  // Handle string inputs like "100000000 views" - extract numeric part
  let numericValue = num;
  if (typeof num === 'string') {
    // Extract numbers from string (handles cases like "100000000 views")
    const match = num.match(/[\d,]+/);
    if (match) {
      numericValue = parseInt(match[0].replace(/,/g, ''), 10);
    } else {
      return '0';
    }
  }
  
  // Convert to number if it's not already
  numericValue = Number(numericValue);
  
  // Check if it's a valid number
  if (isNaN(numericValue)) return '0';
  
  // Format large numbers with K, M, B suffixes
  if (numericValue >= 1000000000) {
    return (numericValue / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
  if (numericValue >= 1000000) {
    return (numericValue / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (numericValue >= 1000) {
    return (numericValue / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  
  return numericValue.toString();
};

export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const getStatusBadgeClass = (status) => {
  const statusClasses = {
    active: 'badge-success',
    inactive: 'badge-gray',
    complete: 'badge-success',
    processing: 'badge-warning',
    failed: 'badge-danger',
    pending: 'badge-warning',
    cancelled: 'badge-gray',
    expired: 'badge-danger',
    trial: 'badge-warning',
    free: 'badge-gray',
    pro: 'badge-success',
    premium: 'badge-success',
    basic: 'badge-success',
    guest: 'badge-gray',
    admin: 'badge-success',
    user: 'badge-gray'
  };
  
  return statusClasses[status] || 'badge-gray';
};

export const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      return true;
    } catch (err) {
      return false;
    } finally {
      document.body.removeChild(textArea);
    }
  }
};

export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const getPlanColor = (plan) => {
  const planColors = {
    guest: 'text-gray-600',
    free: 'text-blue-600', 
    basic: 'text-green-600',
    pro: 'text-purple-600',
    premium: 'text-orange-600'
  };
  return planColors[plan] || 'text-gray-600';
};